export function initBurgerMenu() {
  const burger = document.querySelector("#burger")
  const mainNav = document.querySelector("#main-nav")

  if (!burger || !mainNav) return

  burger.addEventListener("click", toggleMenu)

  function toggleMenu() {
    const isOpen = burger.getAttribute("aria-expanded") === "true"

    burger.setAttribute("aria-expanded", !isOpen)
    mainNav.classList.toggle("is-open")

    // Prevent body scroll when menu is open on mobile
    if (!isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }

  // Close menu on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mainNav.classList.contains("is-open")) {
      toggleMenu()
    }
  })

  // Close menu when clicking any link (main nav or language nav)
  const allLinks = mainNav.querySelectorAll("a")
  allLinks.forEach((link) => {
    link.addEventListener("click", () => {
      document.addEventListener(
        "htmx:afterSettle",
        () => {
          if (mainNav.classList.contains("is-open")) {
            toggleMenu()
          }
        },
        { once: true },
      )
    })
  })
}

export function initScrolledNav() {
  const handleScroll = () => {
    document.body.classList.toggle("-scrolled", window.scrollY > 16)
  }
  handleScroll()
  window.addEventListener("scroll", handleScroll, { passive: true })
}
